export default __webpack_public_path__ + "890f77db2d7c5cd38507b6c05e2d1f7c.svg";